export const POLICIES = {
  // Projects
  ViewProjects: {
    permissions: ['view:projects'],
    fallbackRoles: ['org-admin', 'org-manager']
  },
  ManageProjects: {
    permissions: ['manage:projects'],
    fallbackRoles: ['org-admin', 'org-manager']
  },
  DeleteProjects: {
    permissions: ['delete:projects'],
    fallbackRoles: ['org-admin']
  },

  // Members
  ViewUsers: {
    permissions: ['view:org-members'],
    fallbackRoles: ['org-admin', 'org-manager']
  },
  ManageUsers: {
    permissions: ['manage:org-members'],
    fallbackRoles: ['org-admin', 'org-manager']
  },
  DeleteUsers: {
    permissions: ['delete:org-members'],
    fallbackRoles: ['org-admin']
  },

  // Project Users
  ViewProjectUsers: {
    permissions: ['view:project-team', 'view:org-members'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },
  ManageProjectUsers: {
    permissions: ['manage:project-team', 'manage:org-members'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },
  DeleteProjectUsers: {
    permissions: ['delete:project-team', 'delete:org-members'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Test Cases
  ViewTestCases: {
    permissions: ['view:test-cases'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member', 'executive-manager']
  },
  ManageTestCases: {
    permissions: ['manage:test-cases'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member']
  },
  DeleteTestCases: {
    permissions: ['delete:test-cases'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Test Cycles
  ViewTestCycles: {
    permissions: ['view:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member', 'executive-manager']
  },
  ManageTestCycles: {
    permissions: ['manage:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member']
  },
  DeleteTestCycles: {
    permissions: ['delete:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Test Executions
  ViewTestExecutions: {
    permissions: ['view:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member', 'executive-manager']
  },
  ManageTestExecutions: {
    permissions: ['manage:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member']
  },
  DeleteTestExecutions: {
    permissions: ['delete:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Dashboard
  ViewProjectDashboard: {
    permissions: ['view:project-dashboard'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member', 'executive-manager']
  },

  // Project Configuration
  ViewProjectConfig: {
    permissions: ['view:project-config', 'manage:project-config', 'manage:jira-config', 'manage:project-notifications'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member', 'executive-manager']
  },
  ManageProjectConfig: {
    permissions: ['manage:project-config'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Notifications
  ManageProjectNotifications: {
    permissions: ['manage:project-notifications'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },
  //jira
   ManageJiraConfig: {
    permissions: ['manage:jira-config'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },
  // Test Suites
  ViewTestSuite: {
    permissions: ['view:test-suites'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member', 'executive-manager']
  },
  ManageTestSuite: {
    permissions: ['manage:test-suites'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },
  DeleteTestSuite: {
    permissions: ['delete:test-suites'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Reports
  ViewReports: {
    permissions: ['view:reports'],
    fallbackRoles: ['org-admin', 'org-manager']
  },

  ViewAiAgents: {
    permissions: ['view:ai-agents', 'manage:test-cases'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin', 'team-member']
  },

  // AI Configurations
  ManageAiConfigOrg: {
    permissions: ['manage:ai-config-org'],
    fallbackRoles: ['org-admin', 'org-manager']
  },
  ManageAiConfigProject: {
    permissions: ['manage:ai-config-project'],
    fallbackRoles: ['org-admin', 'org-manager', 'project-admin']
  },

  // Defect Intelligence
  ManageDefectIntelligence: {
    permissions: ['manage:defect-intel'],
    fallbackRoles: ['org-admin', 'org-manager']
  },

  ManageTraceability: {
    permissions: ['manage:traceability', 'manage:test-cases', 'manage:test-cycles'],
    fallbackRoles: ['org-admin', 'org-manager']
  },

  // Org Settings
  ManageOrgSettings: {
    permissions: ['manage:org-settings', 'manage:org-members'],
    fallbackRoles: ['org-admin', 'org-manager']
  },

  // Roles & Permissions Setup
  ManageRolesAndPermissions: {
    permissions: ['manage:roles-permissions'],
    fallbackRoles: ['org-admin']
  },

  DeleteOrgAccount: {
    permissions: ['delete:org'],
    fallbackRoles: ['super-admin', 'org-admin']
  }
};